import React from 'react';
import { formatReceiptDate } from '../MoneyReceipt/MoneyReceiptReport';
import './HotelVoucherTemplate.css';

const VoucherRow = ({ label, value, className = '' }) => (
    <div className={`row ${className}`.trim()}>
        <div className="left">{label}</div>
        <div className="value">{value}</div>
    </div>
);

const formatRooms = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return `${value} Room`;
};

const HotelVoucherTemplate = ({ data }) => {
    if (!data) return null;

    const confirmationId = data.ConfirmationId || '';
    const customerName = (data.CustomerName || '').replace(/\s+/g, ' ').trim();
    const mobile = data.Mobile || '';
    const voucherDate = formatReceiptDate(data.VoucherDate);

    return (
        <div id="hotel-voucher-print-root" className="voucher">
            <div className="header-title">HOTEL VOUCHER</div>

            <div className="top-section">
                <div className="company">
                    <strong>Explore TouristHub Holidays LLP</strong>
                    <br />
                    <b>Corp Office:</b> 63 Ananda Palit Road, Kolkata-700150
                    <br />
                    <b>Registered Office:</b> Asutosh Bhawan, M N Roy Road,
                    <br />
                    Barendrapara, Kol-700149
                    <br />
                    <b>GSTIN:</b> 19AALFE8568J1ZM
                    <br />
                    <b>Ph:</b> +91 98300 17303 / +91 99037 38567
                    <br />
                    <b>E-Mail:</b> touristhubinfo@gmail.com
                    <br />
                    www.touristhubindia.com
                </div>

                <img
                    src={`${process.env.PUBLIC_URL}/eth_logo.png`}
                    className="logo"
                    alt="Explore TouristHub Holidays"
                />
            </div>

            <div className="desc-header">Description</div>

            <div className="two-column">
                <div>
                    <VoucherRow label="Confirmation ID :" value={confirmationId} />
                    <VoucherRow label="Name :" value={customerName} className="row-name" />
                    <VoucherRow label="Mobile :" value={mobile} />
                </div>

                <div>
                    <VoucherRow label="Date :" value={voucherDate} />
                </div>
            </div>

            <div className="line" />

            <VoucherRow label="Booking Type:" value={data.BookingType || ''} />
            <VoucherRow label="Hotel Name:" value={data.HotelName || ''} />
            <VoucherRow label="Location:" value={data.LocationName || ''} />
            <VoucherRow label="Check-in Date:" value={formatReceiptDate(data.CheckInDate)} />
            <VoucherRow label="Check-out Date:" value={formatReceiptDate(data.CheckOutDate)} />
            <VoucherRow label="Room Type:" value={data.RoomType || ''} />
            <VoucherRow label="No. of Nights:" value={data.NoOfNights || ''} />
            <VoucherRow label="No. of Rooms:" value={formatRooms(data.NoOfRooms)} />
            <VoucherRow label="Extra Bed:" value={data.ExtraBed || ''} />
            <VoucherRow label="Meal Plan:" value={data.MealPlan || ''} />
            <VoucherRow label="No. of Adult:" value={data.NoOfAdult || ''} />
            <VoucherRow label="No. of Child:" value={data.NoOfChild || ''} />
            <VoucherRow label="No. of CNB:" value={data.NoOfCNB || ''} />
            <VoucherRow label="Contact Person:" value={data.ContactPersonName || ''} />
            <VoucherRow label="Contact Mobile:" value={data.ContactPersonMobile || ''} />
            <VoucherRow label="Others:" value={data.Others || ''} />

            <div className="thank">Thank You!</div>
        </div>
    );
};

export default HotelVoucherTemplate;
